import React from "react";
import { useSelector } from "react-redux";
import { PFXLandingSubtype } from "../../../../models/Interfaces";
import { LandingComponent } from "../../../../redux/slices/landingSlice";
import Newsletter from "./variants/Newsletter";
import SocialMedia from "./variants/SocialMedia";

interface ISocial {
  component: LandingComponent;
}

const Social = ({ component }: ISocial) => {
  switch (component.subtype) {
    case PFXLandingSubtype.NEWSLETTER:
      return <Newsletter data={component.data} id={component.id} />;
    case PFXLandingSubtype.SOCIALMEDIA:
      return <SocialMedia data={component.data} id={component.id} />;
    default:
      return <Newsletter data={component.data} id={component.id} />;
  }
};
export default Social;
